export const KEY_ACCESS_TOKEN = 'access_token';
export const KEY_REFRESH_TOKEN = 'refresh_token';
export const KEY_USER_DETAILS = 'user';
export const CONFIGS = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  REFRESH_URL: process.env.REACT_APP_REFRESH_URL,
  RAZORPAY_KEY: process.env.REACT_APP_RAZORPAY_KEY,
  RECAPTCHA_SITE_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  // Origin of the ExEd Learn portal the side-nav "Learn" item hands off to.
  LEARN_PORTAL_URL: process.env.REACT_APP_LEARN_PORTAL_URL,
};
export const REGEX = {
  NAME: /^[a-zA-Z]+$/,
  MOBILE: /^(\+\d{1,3}[- ]?)?\d{10}$/,
  PINCODE: /^[0-9]{6,6}$/,
  NUMBER: /[^0-9]/,
  ONLYNUMBER: /^[0-9]*$/,
  FULLNAME: /^[a-zA-Z .,'\s]+$/,
  ALPHA_WITH_SPACE: /^[a-zA-Z\s]+$/,
  ALPHANUMERIC_WITH_SPACE: /^[a-zA-Z0-9\s]+$/,
  NUMBERWITHDECIMAL: /^[+-]?([0-9]+(\.[0-9]{1,2})?|\.[0-9]{1,2})$/,
  ANNUALINCOME: /^\s*(?!0$)\d+(?:\.\d+)?\s*$/,
  DIGITS_ONLY_UPTO_100: /^\-?(([0-9]\d?|0\d{1,2})((\.)\d{0,2})?|100((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_10: /^\-?((0\d|\d)?((\.)\d{0,2})?|10((\.)0{1,2})?)$/,
  DIGITS_ONLY_UPTO_4: /^\-?((0[0-3]|[0-3])?((\.)\d{0,2})?|(4|04)((\.)0{1,2})?)$/,
  PERCENTAGE: /^100$/,
  GMAT: /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$/,
  CGPA: /^10$/,
  GRADE: /^[a-fA-FOoPp]$/,
  MIXED: /^[a-zA-Z0-9]*$/,
  PINCODE: /^[a-zA-Z0-9-./,]*$/,
  AWSSCORE: /^(0|[1-9]\d*)(\.0|\.5)?$/,
  LASTNAME: /^[A-Za-z .,']*$/,
  PASSPORTISSUE: /^[a-zA-Z,]+$/,
  MIXED_ADDRESS: /^[a-zA-Z0-9-.#/, ]*$/,
  PARENT_DOC: /^aadhaarParent/,
  PHONE_NUMBER: /^[0-9]*$/,
  AADHAAR: '^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$',
  ALPHA_SPECIAL: /^[a-zA-Z\s'’]+$/,
  PAN: /^[A-Z]{5}\d{4}[A-Z]$/,
  GRADE2: /^[A-D][1-9]?(\+{1,2})?$/,
  PAN: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
  WEBSITE: /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})(\.[a-zA-Z0-9]{2,})?/,
  EMAIL: /^(?!.*\s)[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_{|}~-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
  SCHOOLORGNAME: /^[a-zA-Z0-9',.\-\s]+$/,
  ARRAYFIELDNAME: /^([a-zA-Z_][\w]*)[\[\.](\d+)[\]\.]?[\[\.]?([a-zA-Z_][\w]*)[\]]?$/,
};
export const TABLET_BREAKPOINT = 'md';
export const SENTRY_DSN = 'https://b7db23742c1d150df851c59170745499@o4506744673861632.ingest.us.sentry.io/4509518165966848';
export const DATA_SALT = '@#&$%*23HGFYTfa65s';
export const MIXPANEL_PROJECTID = '385916d3b2c5b6911b76788a35a5456b';
export const DOCUMENT_NOMENCLATURE = {
  'Passport Size Photo': '_Photograph',
  Signature: '_Signature',
  'SSC/10th Certificate & Marks Sheet': '_SSC_10th_Marksheet',
  'HSC/10th Certificate & Marks Sheet': '_HSC_12th_Marksheet',
  'GRE - CBT Scorecard': '_GRE_CBT_Scorecard',
  'GMAT Scorecard': '_GMAT_Scorecard',
  'GMATFocus Edition Scorecard': '_GMATFocus_Scorecard',
  'CAT Scorecard': '_CAT_Scorecard',
  'Category Certificate': '_Category_Certificate',
  Passport: '_Passport',
  'Proof of Overseas Citizenship/Residence': '_Proof_of_Overseas_Residence',
  'Original Disability certificate': '_Original_Disability_Certificate',
};
export const DOC_ASSIGN_NOMENCLATURE = {
  hed__Education_History__c: 'Academic Documents',
  Employment_History__c: 'Employment Documents',
  Application: 'Personal Identity Documents',
};
export const RECORDTYPE_IDS = {
  workExperiences: 'Work_Experience',
  internationalExposure: 'International_Exposure',
  otherProfessionalDetails: 'Other_Professional_Training',
  researchExperience: 'Research_Experience'
};
export const EDUCATION_TYPES = {
  'educationHistories[0]': '10th',
  'educationHistories[1]': '12th',
  educationHistoriesUg: 'Bachelor',
  educationHistoriesOthers: 'Others',
};
export const APPLICATION_SUB_STATUS_EMBA = {
  0: 'Qualified',
  1: 'Not Qualified',
  2: 'Application Completed',
};
export const APPLICATION_STATUS = {
  0: 'Application Initiated',
  1: 'Application Submitted',
  2: 'Application Fee Paid',
  3: 'Documents Screened',
  4: 'Shortlisted',
  5: 'Interview',
  6: 'Offer Letter',
  7: 'Commitment Fee Paid',
  8: 'Term 1 Fee Paid',
  9: 'Withdrawal',
  10: 'Admitted',
};
export const DOCUMENT_STATUS = {
  Pending: ['Pending Upload', 'Interim Rejected', 'Final Reject'],
  Submitted: ['Pending Review', 'Interim Accepted', 'Interim Rejected'],
};

export const EMBA = 'EMBA';
export const TYMBA = 'Master of Business Administration (MBA)';

export const DOCUMENT_REJECTS_STATUS = 'Not Meeting Eligibility Criteria';
export const COUNTRY_LIST = [
  {
    name: 'India',
    value: 'IN',
  },
  {
    name: 'Afghanistan',
    value: 'AF',
  },
  {
    name: 'Albania',
    value: 'AL',
  },
  {
    name: 'Algeria',
    value: 'DZ',
  },
  {
    name: 'American Samoa',
    value: 'AS',
  },
  {
    name: 'Andorra',
    value: 'AD',
  },
  {
    name: 'Angola',
    value: 'AO',
  },
  {
    name: 'Anguilla',
    value: 'AI',
  },
  {
    name: 'Antarctica',
    value: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    value: 'AG',
  },
  {
    name: 'Argentina',
    value: 'AR',
  },
  {
    name: 'Armenia',
    value: 'AM',
  },
  {
    name: 'Aruba',
    value: 'AW',
  },
  {
    name: 'Australia',
    value: 'AU',
  },
  {
    name: 'Austria',
    value: 'AT',
  },
  {
    name: 'Azerbaijan',
    value: 'AZ',
  },
  {
    name: 'Bahamas',
    value: 'BS',
  },
  {
    name: 'Bahrain',
    value: 'BH',
  },
  {
    name: 'Bangladesh',
    value: 'BD',
  },
  {
    name: 'Barbados',
    value: 'BB',
  },
  {
    name: 'Belarus',
    value: 'BY',
  },
  {
    name: 'Belgium',
    value: 'BE',
  },
  {
    name: 'Belize',
    value: 'BZ',
  },
  {
    name: 'Benin',
    value: 'BJ',
  },
  {
    name: 'Bermuda',
    value: 'BM',
  },
  {
    name: 'Bhutan',
    value: 'BT',
  },
  {
    name: 'Bolivia',
    value: 'BO',
  },
  {
    name: 'Bosnia and Herzegowina',
    value: 'BA',
  },
  {
    name: 'Botswana',
    value: 'BW',
  },
  {
    name: 'Bouvet Island',
    value: 'BV',
  },
  {
    name: 'Brazil',
    value: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    value: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    value: 'BN',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    value: 'BQ',
  },
  {
    name: 'Saint Barthelemy',
    value: 'BL',
  },
  {
    name: 'Bulgaria',
    value: 'BG',
  },
  {
    name: 'Burkina Faso',
    value: 'BF',
  },
  {
    name: 'Burundi',
    value: 'BI',
  },
  {
    name: 'Cambodia',
    value: 'KH',
  },
  {
    name: 'Cameroon',
    value: 'CM',
  },
  {
    name: 'Canada',
    value: 'CA',
  },
  {
    name: 'Cape Verde',
    value: 'CV',
  },
  {
    name: 'Cayman Islands',
    value: 'KY',
  },
  {
    name: 'Central African Republic',
    value: 'CF',
  },
  {
    name: 'Chad',
    value: 'TD',
  },
  {
    name: 'Chile',
    value: 'CL',
  },
  {
    name: 'China',
    value: 'CN',
  },
  {
    name: 'Christmas Island',
    value: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    value: 'CC',
  },
  {
    name: 'Colombia',
    value: 'CO',
  },
  {
    name: 'Comoros',
    value: 'KM',
  },
  {
    name: 'Congo',
    value: 'CG',
  },
  {
    name: 'Congo Democratic Republic of',
    value: 'CD',
  },
  {
    name: 'Cook Islands',
    value: 'CK',
  },
  {
    name: 'Costa Rica',
    value: 'CR',
  },
  {
    name: 'Croatia',
    value: 'HR',
  },
  {
    name: 'Cuba',
    value: 'CU',
  },
  {
    name: 'Cyprus',
    value: 'CY',
  },
  {
    name: 'Czech Republic',
    value: 'CZ',
  },
  {
    name: 'Denmark',
    value: 'DK',
  },
  {
    name: 'Djibouti',
    value: 'DJ',
  },
  {
    name: 'Dominica',
    value: 'DM',
  },
  {
    name: 'Dominican Republic',
    value: 'DO',
  },
  {
    name: 'Timor-Leste',
    value: 'TL',
  },
  {
    name: 'Ecuador',
    value: 'EC',
  },
  {
    name: 'Egypt',
    value: 'EG',
  },
  {
    name: 'El Salvador',
    value: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    value: 'GQ',
  },
  {
    name: 'Eritrea',
    value: 'ER',
  },
  {
    name: 'Estonia',
    value: 'EE',
  },
  {
    name: 'Ethiopia',
    value: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    value: 'FK',
  },
  {
    name: 'Faroe Islands',
    value: 'FO',
  },
  {
    name: 'Fiji',
    value: 'FJ',
  },
  {
    name: 'Finland',
    value: 'FI',
  },
  {
    name: 'France',
    value: 'FR',
  },
  {
    name: 'French Guiana',
    value: 'GF',
  },
  {
    name: 'French Polynesia',
    value: 'PF',
  },
  {
    name: 'French Southern Territories',
    value: 'TF',
  },
  {
    name: 'Gabon',
    value: 'GA',
  },
  {
    name: 'Gambia',
    value: 'GM',
  },
  {
    name: 'Georgia',
    value: 'GE',
  },
  {
    name: 'Germany',
    value: 'DE',
  },
  {
    name: 'Ghana',
    value: 'GH',
  },
  {
    name: 'Gibraltar',
    value: 'GI',
  },
  {
    name: 'Greece',
    value: 'GR',
  },
  {
    name: 'Greenland',
    value: 'GL',
  },
  {
    name: 'Grenada',
    value: 'GD',
  },
  {
    name: 'Guadeloupe',
    value: 'GP',
  },
  {
    name: 'Guam',
    value: 'GU',
  },
  {
    name: 'Guatemala',
    value: 'GT',
  },
  {
    name: 'Guinea',
    value: 'GN',
  },
  {
    name: 'Guinea-bissau',
    value: 'GW',
  },
  {
    name: 'Guyana',
    value: 'GY',
  },
  {
    name: 'Haiti',
    value: 'HT',
  },
  {
    name: 'Heard Island and McDonald Islands',
    value: 'HM',
  },
  {
    name: 'Honduras',
    value: 'HN',
  },
  {
    name: 'Hong Kong',
    value: 'HK',
  },
  {
    name: 'Hungary',
    value: 'HU',
  },
  {
    name: 'Iceland',
    value: 'IS',
  },
  {
    name: 'Indonesia',
    value: 'ID',
  },
  {
    name: 'Iran (Islamic Republic of)',
    value: 'IR',
  },
  {
    name: 'Iraq',
    value: 'IQ',
  },
  {
    name: 'Ireland',
    value: 'IE',
  },
  {
    name: 'Israel',
    value: 'IL',
  },
  {
    name: 'Italy',
    value: 'IT',
  },
  {
    name: 'Jamaica',
    value: 'JM',
  },
  {
    name: 'Japan',
    value: 'JP',
  },
  {
    name: 'Jordan',
    value: 'JO',
  },
  {
    name: 'Kazakhstan',
    value: 'KZ',
  },
  {
    name: 'Kenya',
    value: 'KE',
  },
  {
    name: 'Kiribati',
    value: 'KI',
  },
  {
    name: "Korea, Democratic People's Republic of",
    value: 'KP',
  },
  {
    name: 'South Korea',
    value: 'KR',
  },
  {
    name: 'Kuwait',
    value: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    value: 'KG',
  },
  {
    name: "Lao People's Democratic Republic",
    value: 'LA',
  },
  {
    name: 'Latvia',
    value: 'LV',
  },
  {
    name: 'Lebanon',
    value: 'LB',
  },
  {
    name: 'Lesotho',
    value: 'LS',
  },
  {
    name: 'Liberia',
    value: 'LR',
  },
  {
    name: 'Libya',
    value: 'LY',
  },
  {
    name: 'Liechtenstein',
    value: 'LI',
  },
  {
    name: 'Lithuania',
    value: 'LT',
  },
  {
    name: 'Luxembourg',
    value: 'LU',
  },
  {
    name: 'Macao',
    value: 'MO',
  },
  {
    name: 'Macedonia, The Former Yugoslav Republic of',
    value: 'MK',
  },
  {
    name: 'Madagascar',
    value: 'MG',
  },
  {
    name: 'Malawi',
    value: 'MW',
  },
  {
    name: 'Malaysia',
    value: 'MY',
  },
  {
    name: 'Maldives',
    value: 'MV',
  },
  {
    name: 'Mali',
    value: 'ML',
  },
  {
    name: 'Malta',
    value: 'MT',
  },
  {
    name: 'Marshall Islands',
    value: 'MH',
  },
  {
    name: 'Martinique',
    value: 'MQ',
  },
  {
    name: 'Mauritania',
    value: 'MR',
  },
  {
    name: 'Mauritius',
    value: 'MU',
  },
  {
    name: 'Mayotte',
    value: 'YT',
  },
  {
    name: 'Mexico',
    value: 'MX',
  },
  {
    name: 'Micronesia, Federated States of',
    value: 'FM',
  },
  {
    name: 'Moldova',
    value: 'MD',
  },
  {
    name: 'Monaco',
    value: 'MC',
  },
  {
    name: 'Mongolia',
    value: 'MN',
  },
  {
    name: 'Montserrat',
    value: 'MS',
  },
  {
    name: 'Morocco',
    value: 'MA',
  },
  {
    name: 'Mozambique',
    value: 'MZ',
  },
  {
    name: 'Myanmar',
    value: 'MM',
  },
  {
    name: 'Namibia',
    value: 'NA',
  },
  {
    name: 'Nauru',
    value: 'NR',
  },
  {
    name: 'Nepal',
    value: 'NP',
  },
  {
    name: 'Netherlands',
    value: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    value: 'AN',
  },
  {
    name: 'New Caledonia',
    value: 'NC',
  },
  {
    name: 'New Zealand',
    value: 'NZ',
  },
  {
    name: 'Nicaragua',
    value: 'NI',
  },
  {
    name: 'Niger',
    value: 'NE',
  },
  {
    name: 'Nigeria',
    value: 'NG',
  },
  {
    name: 'Niue',
    value: 'NU',
  },
  {
    name: 'Norfolk Island',
    value: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    value: 'MP',
  },
  {
    name: 'Norway',
    value: 'NO',
  },
  {
    name: 'Oman',
    value: 'OM',
  },
  {
    name: 'Pakistan',
    value: 'PK',
  },
  {
    name: 'Palau',
    value: 'PW',
  },
  {
    name: 'Panama',
    value: 'PA',
  },
  {
    name: 'Papua New Guinea',
    value: 'PG',
  },
  {
    name: 'Paraguay',
    value: 'PY',
  },
  {
    name: 'Peru',
    value: 'PE',
  },
  {
    name: 'Philippines',
    value: 'PH',
  },
  {
    name: 'Pitcairn',
    value: 'PN',
  },
  {
    name: 'Poland',
    value: 'PL',
  },
  {
    name: 'Portugal',
    value: 'PT',
  },
  {
    name: 'Puerto Rico',
    value: 'PR',
  },
  {
    name: 'Qatar',
    value: 'QA',
  },
  {
    name: 'Reunion',
    value: 'RE',
  },
  {
    name: 'Romania',
    value: 'RO',
  },
  {
    name: 'Russian Federation',
    value: 'RU',
  },
  {
    name: 'Rwanda',
    value: 'RW',
  },
  {
    name: 'Saint Kitts and Nevis',
    value: 'KN',
  },
  {
    name: 'Saint Lucia',
    value: 'LC',
  },
  {
    name: 'Saint Martin (French part)',
    value: 'MF',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    value: 'VC',
  },
  {
    name: 'Samoa',
    value: 'WS',
  },
  {
    name: 'San Marino',
    value: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    value: 'ST',
  },
  {
    name: 'Saudi Arabia',
    value: 'SA',
  },
  {
    name: 'Senegal',
    value: 'SN',
  },
  {
    name: 'Seychelles',
    value: 'SC',
  },
  {
    name: 'Sierra Leone',
    value: 'SL',
  },
  {
    name: 'Singapore',
    value: 'SG',
  },
  {
    name: 'Slovakia (Slovak Republic)',
    value: 'SK',
  },
  {
    name: 'Slovenia',
    value: 'SI',
  },
  {
    name: 'Solomon Islands',
    value: 'SB',
  },
  {
    name: 'Somalia',
    value: 'SO',
  },
  {
    name: 'South Africa',
    value: 'ZA',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    value: 'GS',
  },
  {
    name: 'South Sudan',
    value: 'SS',
  },
  {
    name: 'Spain',
    value: 'ES',
  },
  {
    name: 'Sri Lanka',
    value: 'LK',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    value: 'SH',
  },
  {
    name: 'St. Pierre and Miquelon',
    value: 'PM',
  },
  {
    name: 'Sudan',
    value: 'SD',
  },
  {
    name: 'Suriname',
    value: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen Islands',
    value: 'SJ',
  },
  {
    name: 'Swaziland',
    value: 'SZ',
  },
  {
    name: 'Sweden',
    value: 'SE',
  },
  {
    name: 'Switzerland',
    value: 'CH',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    value: 'SX',
  },
  {
    name: 'Syrian Arab Republic',
    value: 'SY',
  },
  {
    name: 'Taiwan',
    value: 'TW',
  },
  {
    name: 'Tajikistan',
    value: 'TJ',
  },
  {
    name: 'Tanzania, United Republic of',
    value: 'TZ',
  },
  {
    name: 'Thailand',
    value: 'TH',
  },
  {
    name: 'Togo',
    value: 'TG',
  },
  {
    name: 'Tokelau',
    value: 'TK',
  },
  {
    name: 'Tonga',
    value: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    value: 'TT',
  },
  {
    name: 'Tunisia',
    value: 'TN',
  },
  {
    name: 'Turkey',
    value: 'TR',
  },
  {
    name: 'Turkmenistan',
    value: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    value: 'TC',
  },
  {
    name: 'Tuvalu',
    value: 'TV',
  },
  {
    name: 'Uganda',
    value: 'UG',
  },
  {
    name: 'Ukraine',
    value: 'UA',
  },
  {
    name: 'United Arab Emirates',
    value: 'AE',
  },
  {
    name: 'United Kingdom',
    value: 'GB',
  },
  {
    name: 'United States of America',
    value: 'US',
  },
  {
    name: 'United States Minor Outlying Islands',
    value: 'UM',
  },
  {
    name: 'Uruguay',
    value: 'UY',
  },
  {
    name: 'Uzbekistan',
    value: 'UZ',
  },
  {
    name: 'Vanuatu',
    value: 'VU',
  },
  {
    name: 'Vatican City State (Holy See)',
    value: 'VA',
  },
  {
    name: 'Venezuela',
    value: 'VE',
  },
  {
    name: 'Vietnam',
    value: 'VN',
  },
  {
    name: 'Virgin Islands (British)',
    value: 'VG',
  },
  {
    name: 'Virgin Islands (U.S.)',
    value: 'VI',
  },
  {
    name: 'Wallis and Futuna Islands',
    value: 'WF',
  },
  {
    name: 'Western Sahara',
    value: 'EH',
  },
  {
    name: 'Yemen',
    value: 'YE',
  },
  {
    name: 'Serbia',
    value: 'RS',
  },
  {
    name: 'Zambia',
    value: 'ZM',
  },
  {
    name: 'Zimbabwe',
    value: 'ZW',
  },
  {
    name: 'Aaland Islands',
    value: 'AX',
  },
  {
    name: 'Palestine',
    value: 'PS',
  },
  {
    name: 'Montenegro',
    value: 'ME',
  },
  {
    name: 'Guernsey',
    value: 'GG',
  },
  {
    name: 'Isle of Man',
    value: 'IM',
  },
  {
    name: 'Jersey',
    value: 'JE',
  },
  {
    name: 'CuravBao',
    value: 'CW',
  },
  {
    name: 'Ivory Coast',
    value: 'CI',
  },
  {
    name: 'Kosovo',
    value: 'XK',
  },
  {
    name: 'Others',
    value: 'OT',
  },
];

export const errorcode = {
  404: 'User not verified',
  403: 'User not found',
};
